import { createFileRoute } from "@tanstack/react-router";
import LiveRoom from "@/pages/LiveRoom";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta } from "@/lib/routeSocial";

export const Route = createFileRoute("/live/")({
  head: () => ({
    meta: socialMeta({
        seo: { topics: ["live"] },
      title: "Live Scores & Match Intelligence — Statlign Live Room",
      description:
        "Live scores, upcoming fixtures and settled results across football, basketball, NFL, tennis, cricket and more — each with the model's pick, confidence and reasoning.",
    }),
  }),
  component: () => (
    <MainLayout>
      <LiveRoom />
    </MainLayout>
  ),
});
